/**
 * @desc 出库
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.FulfilmentOutRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/test/fulfilmentOut`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
